/* eslint-disable no-use-before-define */
import _ from 'lodash';

import { safeToBig } from 'shared/helpers/utils_math';
import { getProductNetWeightInGrams } from 'shared/helpers/products';
import { getFlowerEquivalent } from 'shared/helpers/check-limits';
import { getTypeLimits, getLimitMessage } from '../utils';

export function isSolidEdible({ type, subcategory }) {
  const isLiquid = subcategory === 'drinks';
  return type === 'Edible' && !isLiquid;
}

export function checkSolidEdibleNetWeight(cart) {
  const { solidEdibleNetWeightLimit } = getTypeLimits(cart);
  const weightInGrams = getTotalSolidGramsForCart(cart);
  const message = getLimitMessage('solid edibles', solidEdibleNetWeightLimit);

  return weightInGrams > solidEdibleNetWeightLimit
    ? {
        total: weightInGrams,
        message,
        withinLimits: false,
      }
    : { withinLimits: true };
}

export function getTotalSolidGramsForCart({ orders, state, limits, medical }) {
  return Number(
    _.reduce(
      orders,
      (previous, order) => {
        const { product, quantity } = order;
        if (!isSolidEdible(product)) {
          return safeToBig(previous);
        }
        const netWeightInGrams = getProductNetWeightInGrams(product);
        const totalNetWeight = netWeightInGrams * quantity;

        const isBritishColumbiaDispensary = state === 'BC';
        const flowerEquivalent = getFlowerEquivalent(order, medical, limits);
        const useEquivalent = isBritishColumbiaDispensary && !!flowerEquivalent;

        return safeToBig(previous).plus(useEquivalent ? flowerEquivalent : totalNetWeight);
      },
      0.0
    )
  );
}
